import { DomainConf } from "@wwg/domain-conf";

/**
 * Define configurations here to be loaded based on the domain
 * the app is being served from.
 */
const env = new DomainConf()
  .forDomain("localhost", {
    apiBase: "https://dev-api.wwdb.com",
    //apiBase: "http://localhost:3751",
    coreBffUrl: "https://dev-api.wwdb.com/v1/core",
    localDevMode: true, // Set to true to enable local login for developers.
    //WEB_APP_COUNTRY: "AU",
    WEB_APP_COUNTRY: "US",

    ideaCenterUrl: "https://app-profile-web-dev.wwdb.com/verification",
    helpUrl: "https://app-help-web-dev.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup-dev.wwdb.com/",
    environmentApp: "dev",
  })
  .forDomain("dev-settings.wwdb.com", {
    WEB_APP_COUNTRY: "US",
    apiBase: "https://dev-api.wwdb.com",
    coreBffUrl: "https://dev-api.wwdb.com/v1/core",

    ideaCenterUrl: "https://app-profile-web-dev.wwdb.com/verification",
    helpUrl: "https://app-help-web-dev.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup-dev.wwdb.com/",
    environmentApp: "dev",
  })
    .forDomain("settings-dev.wwdb.com", {
    WEB_APP_COUNTRY: "US",
    apiBase: "https://dev-api.wwdb.com",
    coreBffUrl: "https://dev-api.wwdb.com/v1/core",

    ideaCenterUrl: "https://app-profile-web-dev.wwdb.com/verification",
    helpUrl: "https://app-help-web-dev.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup-dev.wwdb.com/",
    environmentApp: "dev",
  })
  .forDomain("settings-staging.wwdb.com", {
    WEB_APP_COUNTRY: "US",
    apiBase: "https://api-staging.wwdb.com",
    coreBffUrl: "https://api-staging.wwdb.com/v1/core",

    ideaCenterUrl: "https://app-profile-web.wwdb.com/verification",
    helpUrl: "https://app-help-web.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup.wwdb.com/",
  })
  .forDomain("settings.wwdb.com", {
    WEB_APP_COUNTRY: "US",
    apiBase: "https://api.wwdb.com",
    coreBffUrl: "https://api.wwdb.com/v1/core",

    ideaCenterUrl: "https://app-profile-web.wwdb.com/verification",
    helpUrl: "https://app-help-web.wwdb.com/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com",
    signUp: "https://signup.wwdb.com/",
  })
  .forDomain("settings.wwdb.com.au", {
    WEB_APP_COUNTRY: "AU",
    apiBase: "https://api.wwdb.com.au",
    coreBffUrl: "https://api.wwdb.com.au/v1/core",
    ideaCenterUrl: "https://app-profile-web.wwdb.com.au/verification",
    helpUrl: "https://app-help-web.wwdb.com.au/help",
    receiptsUrl: "https://app-receipts-web.wwdb.com.au",
    signUp: "https://signup.wwdb.com.au/",
  });

// Export the selected configuration from this file. You can import this wherever you need to use it.
export default env.current;
